module.exports = "../fonts/expand_more_black_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/expand_more_black_icon.svg
// module id = 328
// module chunks = 0